import { render, staticRenderFns } from "./piePlace.vue?vue&type=template&id=27ee1afa&scoped=true&"
import script from "./piePlace.vue?vue&type=script&lang=js&"
export * from "./piePlace.vue?vue&type=script&lang=js&"
import style0 from "./piePlace.vue?vue&type=style&index=0&id=27ee1afa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ee1afa",
  null
  
)

export default component.exports